export default ({ request }) => ({
  noticeOrderListApi(data = {}) {
    return request({
      url: '/factory/notice/order/list',
      method: 'post',
      data,
    })
  },
  noticeOrderDetailApi(data = {}) {
    return request({
      url: '/factory/notice/order/detail',
      method: 'post',
      data,
    })
  },
  noticeOrderListByNewApi(data = {}) {
    return request({
      url: '/factory/notice/order/listByNew',
      method: 'post',
      data,
    })
  },
  noticeOrderSelectListByNewApi(data = {}) {
    return request({
      url: '/factory/notice/order/selectListByNew',
      method: 'post',
      data,
    })
  },
  noticeOrderSetNcApi(data = {}) {
    return request({
      url: '/factory/notice/order/setNc',
      method: 'post',
      data,
    })
  },
  noticeOrderBatchUpdateBizPersonApi(data = {}) {
    return request({
      url: '/factory/notice/order/batch/update/biz/person',
      method: 'post',
      data,
    })
  },
  noticeOrderBatchUpdateFactoryApi(data = {}) {
    return request({
      url: '/factory/notice/order/batch/update/factoryOrderNo',
      method: 'post',
      data,
    })
  },
  noticeOrderListByChangeApi(data = {}) {
    return request({
      url: '/factory/notice/order/listByChange',
      method: 'post',
      data,
    })
  },
  noticeOrderListByTerminatedApi(data = {}) {
    return request({
      url: '/factory/notice/order/listByTerminated',
      method: 'post',
      data,
    })
  },
  noticeOrderPdCostsCalcApi(data = {}) {
    return request({
      url: '/factory/notice/order/pdCostsCalc',
      method: 'post',
      data,
    })
  },
  noticeOrderGeneratePlanApi(data = {}) {
    return request({
      url: '/factory/notice/order/generatePlan',
      method: 'post',
      data,
    })
  },
  noticeOrderGoodsTreeApi(data = {}) {
    return request({
      url: '/factory/notice/order/goods/tree',
      method: 'post',
      data,
      timeout: 30000,
    })
  },
  noticeOrderGoodsSetNcApi(data = {}) {
    return request({
      url: '/factory/notice/order/goods/setNc',
      method: 'post',
      data,
    })
  },
  noticeOrderGoodsSpecSetNcApi(data = {}) {
    return request({
      url: '/factory/notice/order/goods/spec/setNc',
      method: 'post',
      data,
    })
  },
  noticeOrderGoodsNcCompleteApi(data = {}) {
    return request({
      url: '/factory/notice/order/goods/ncComplete',
      method: 'post',
      data,
    })
  },
  noticeOrderBackNoticeOrderStatusApi(data = {}) {
    return request({
      url: '/factory/notice/order/backNoticeOrderStatus',
      method: 'post',
      data,
    })
  },
  noticeOrderRegenerateApi(data = {}) {
    return request({
      url: '/factory/notice/order/regenerate',
      method: 'post',
      data,
    })
  },
})
